import { useFullStorySync } from '@/hooks/useFullStorySync';

/**
 * Keeps FullStory tracking in sync with the logged-in user's experience.
 * Place this inside the app's provider tree.
 */
export const FullStorySync = ({ children }: { children: React.ReactNode }) => {
  useFullStorySync();
  return <>{children}</>;
};
